import { Action, Selector, State, StateContext, Store } from "@ngxs/store";
import { CampaignStateModel } from "./emailcampaign-model";
import { Injectable } from "@angular/core";
import { Campaign } from "../../models/emailcampaign";
import { Users } from "../user/user-actions";
import { EmailCampaignService } from "../../services/emailcampaign.service";
import { lastValueFrom } from "rxjs";
import { CampaignStateActions } from "./emailcampaign-actions";

@State<CampaignStateModel>
    (
        {
            name: "emailCampaigns",
            defaults:
            {
                loadedCampaigns: []
            }
        }
    )
@Injectable({ providedIn: 'root' })
export class EmailCampaignState {
    constructor
        (
            private _campaignService: EmailCampaignService,
        ) {

    }
    @Selector()
    static campaigns(state: CampaignStateModel) {
        return state.loadedCampaigns;
    }

    @Action(CampaignStateActions.LoadCampaigns)
    async loadCampaigns(ctx: StateContext<CampaignStateModel>) {
        const state = ctx.getState();
        let campaigns = await lastValueFrom(this._campaignService.getAll());
        ctx.setState
            (
                {
                    ...state,
                    loadedCampaigns: campaigns,
                }
            );
    }
}